export default __webpack_public_path__ + "static/media/spark_42.6e013c5d.png";